import { Role } from '@guiker/permissions'

import { BackgroundCheckActions } from '../background-check-actions'
import { BackgroundCheckRoleNames } from '../role-names'

export const SpectatorRole: Role = {
  name: BackgroundCheckRoleNames.SPECTATOR,
  permissions: [{ action: BackgroundCheckActions.ViewBackgroundCheck }],
}
